import React, {useEffect, useState, useRef} from "react";
import gsap from 'gsap';
import isMobile from "ismobilejs";

import styles from "./Timeline.module.scss";

export default function Timeline (){
    const popin  = useRef(null);
    const timeline  = useRef(null);
    const [timelineText, setTimelineText] = useState(null);

    useEffect(() => {
        const dataTimeline = [
            `Un laboratoire de robotique de Tsukuba au Japon parvient à faire fonctionner une voiture autonome sur un circuit adapté, grâce à une technologie de suivi de trajectoire avec une reconnaissance du marquage au sol. La vitesse de 30 km/h était atteinte, un exploit pour les chercheurs.`,
            `Bosch commercialise son ABS (« Antiblockiersystem »), premier système électronique prenant le relais du conducteur en cas d'urgence. A la fin des années 1980, les voitures s’engagent discrètement sur la voie de l'automatisation.`,
            `En coopération avec une équipe de l’université de la Bundeswehr à Munich, le constructeur allemand Mercedes-Benz teste une camionnette automatique équipée de caméras. Le véhicule atteint 100 km/h sur un réseau routier sans trafic.`,
            `L’automatisation dans les transports en commun est en marche dans le monde depuis le début des années 80, avec une première expérience en 1981 à Kobe au Japon.`,
            `L’Union européenne lance le programme « Prometheus » (PROgraMme for a European Traffic of Highest Efficiency and Unprecedented Safety) pour développer la conduite automobile automatique, représentant un investissement de 800 millions d’euros.`,
            `Une Mercedes équipée de capteurs parcourt plus de 1.500 kilomètres sur autoroute entre Munich et Copenhague, avec une vitesse maximale de 175 km/h, soit la plus longue section de conduite autonome, dont 158 km sans interventions importantes humaines.`,
            `La Darpa, agence du Pentagone chargée de la recherche avancée, organise sa première compétition de voitures sans chauffeur, Grand Challenge. Deux autres suivront en 2005 et 2007.`,
            `Google commence à tester une voiture équipée d'un système de pilotage automatique, pour automobile aidé de radars, caméras vidéo et GPS, déjà installé sur sept véhicules (six Toyota Prius, une Audi TT) qui ont parcouru plus de 225.000 kilomètres en Californie, sans avoir provoqué d'accident.`,
            `Après des démonstrations de Mercedes ou Audi, Carlos Ghosn promet que l'alliance Renault-Nissan commercialisera des voitures autonomes « à un coût raisonnable » dès 2020.`,
            `La National Highway Traffic Safety Administration (NHTSA) publie un rapport de recherche sur la technologie de communication entre véhicules V2V. Il comprend des résultats de recherches menées par les ministères de la faisabilité technique, de la vie privée et de la sécurité, montrant deux applications de sécurité (Left Turn Assist et Intersection Movement Assist) qui pourraient empêcher jusqu'à 592.000 accidents et sauver 1.083 vies par an.`,
            `L’aspect le plus important du semi-pilote automatique de Tesla a été fourni sous forme de mise à jour séparée. Le pilote automatique a été lancé à la fin de 2015 et peut être utilisé en mains libres sur les autoroutes et les autoroutes. Mise à jour logicielle de nuit pour les propriétaires de Model S.`,
            `La voiture autonome de Google entre en collision avec un bus à vitesse réduite, à cause d'une mauvaise analyse de la situation. L’accident s’est déroulé à vitesse réduite.`,
            `En France, une ordonnance du 3 août 2016 prévoit l'expérimentation de véhicules à délégation de conduite sur les voies publiques.`,
            `Six ans après son projet de voiture sans conducteur doté d’un dispositif de déplacement autonome, encore expérimental et imparfait, Google réorganise son activité et lance une filiale dédiée : Waymo.`,
            `Waymo, la filiale d'Alphabet Google, ouvre au public son service de taxis autonomes dans la banlieue de Phoenix en Arizona (Etats-Unis).`,
            `Nissan annonce avoir déjà mis sur les routes 500.000 voitures équipées de la technologie « ProPilot » et donc semi-autonomes.`,
            `L'agence américaine de la Sécurité routière (NHTSA) ouvre une enquête après une série d'accidents impliquant le système d'aide à la conduite de Tesla. Alors que les accidents de la route mortels ont bondi l'an dernier, l'agence demande des remontées d'information à tous les constructeurs.`
        ];

        const buttons = timeline.current.querySelectorAll('.button--plus');

        Object.values(buttons).map(button =>
            button.addEventListener('click', () => {
                const svg = timeline.current.querySelector('#Timeline');

                const index = parseFloat(button.id.replace('more-', ''));
                const buttonRect = button.getBoundingClientRect();
                setTimelineText(dataTimeline[index-1]);

                const popinRect = popin.current.getBoundingClientRect();

                gsap.set(popin.current.querySelector('span'), {
                    rotate: 0,
                });

                let topValue = buttonRect.top - button.closest(`.${styles.Wrapper}`).getBoundingClientRect().top;

                if (buttonRect.top + popinRect.height >  button.closest(`.${styles.Wrapper}`).getBoundingClientRect().bottom) {
                    topValue = buttonRect.top - button.closest(`.${styles.Wrapper}`).getBoundingClientRect().top - (popinRect.height - buttonRect.height);
                    popin.current.classList.add('align--bottom')
                } else {
                    popin.current.classList.remove('align--bottom')
                }

                gsap.set(popin.current, {
                    top: topValue,
                    left: buttonRect.left + -(svg.getBoundingClientRect().left)
                });

                gsap.to(popin.current.querySelector('span'), .3, {
                    rotate: 45
                })
            })
        );
    }, []);

    useEffect(() => {
        if (timelineText){
            popin.current?.querySelector('span').addEventListener('click', (e) => {
                setTimelineText(null);
            }, { passive: true});
        }
    }, [timelineText]);

    //Scroll Handler
    useEffect(() => {
        const animationDelay = 3;
        const dateCircles = document.querySelectorAll('.date--circle');
        const delayTranche = animationDelay/dateCircles.length;

        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        window.addEventListener('scroll', () => {
            const timelineRect = timeline.current.getBoundingClientRect();

            if (timelineRect.top <= vh/2) {
                timeline.current.querySelector('#Timeline').classList.add('animated');

                Object.values(dateCircles).map((item, index) =>
                    gsap.to(item, 1, {
                        transformBox: 'fill-box',
                        x: 0,
                        y: 0,
                        scale: 1,
                        delay: delayTranche * (index+1),
                        onComplete: () => {
                            gsap.to(item.nextElementSibling, .3, {
                                opacity: 1
                            })
                        }
                    })
                );
            }
        })
    }, []);

    const plus = `
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
        <path d="M6,10 L14,10" id="Line-2" stroke="#000000" stroke-linecap="square"/>
        <path d="M6,10 L14,10" id="Line-2-Copy" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
    </g>
</svg>`

    const svg = `
<svg id="Timeline" width="1400px" height="800px" viewBox="0 0 1400 800" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <rect x="0" y="0" width="1400" height="800" rx="20"/>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-20.000000, -1840.000000)">
            <g transform="translate(20.000000, 1840.000000)">
                <g>
                    <path class="timeline--line" d="M702.645791,-371.129599 L702.645791,-300.904013 C702.645791,-245.675538 657.874266,-200.904013 602.645791,-200.904013 L480.185752,-200.904013 C430.542418,-200.904013 390.298545,-160.66014 390.298545,-111.016806 L390.298545,-111.016806 C390.298545,-61.3734726 430.542418,-21.1295993 480.185752,-21.1295993 L682.645791,-21.1295993 C737.874266,-21.1295993 782.645791,23.6419258 782.645791,78.8704007 L782.645791,118.870401 C782.645791,174.098876 737.874266,218.870401 682.645791,218.870401 L569.71783,218.870401 C514.489355,218.870401 469.71783,263.641926 469.71783,318.870401 C469.71783,319.00987 469.718122,319.149339 469.718705,319.288807 L469.881885,358.288807 C470.112281,413.353472 514.815863,457.870401 569.88101,457.870401 L760.087808,457.870401 C815.316283,457.870401 860.087808,502.641926 860.087808,557.870401 L860.087808,587.870401 C860.087808,643.098876 815.316283,687.870401 760.087808,687.870401 L649.298545,687.870401 C594.07007,687.870401 549.298545,732.641926 549.298545,787.870401 L549.298545,828.870401 C549.298545,884.098876 594.07007,928.870401 649.298545,928.870401 L840.087808,928.870401 C895.316283,928.870401 940.087808,973.641926 940.087808,1028.8704 L940.087808,1028.8704 L940.087808,1159.25675" stroke="#74B743" stroke-width="2" stroke-linecap="square"  transform="translate(665.193176, 394.063577) scale(-1, -1) rotate(90.000000) translate(-665.193176, -394.063577) "/>
                    <path class="timeline--line-2" d="M985.747548,225.747548 L985.697798,267.435367 C985.631945,322.617204 940.879746,367.316029 885.697869,367.316029 L790.683971,367.316029" stroke="#EAF9DB" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"  transform="translate(888.215759, 296.531789) scale(-1, -1) rotate(90.000000) translate(-888.215759, -296.531789) "/>
                    <g >
                        <g transform="translate(45.000000, 404.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Premier test</tspan>
                                    <tspan x="0" y="30">au Japon</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-1">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">1977</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(45.000000, 535.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Arrivée de</tspan>
                                    <tspan x="0" y="30">l’ABS</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-2">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">1978</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(156.000000, 643.000000)">
                            <g transform="translate(65.000000, 29.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Première ligne de métro </tspan>
                                    <tspan x="0" y="30">sans conducteur à Kobe</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-3">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">1981</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(225.000000, 495.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="15">La camionnette </tspan>
                                    <tspan x="0" y="31">automatique de </tspan>
                                    <tspan x="0" y="47">Mercedes-Benz</tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-4">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">1984</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(225.000000, 364.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Lancement du </tspan>
                                    <tspan x="0" y="30">programme européen </tspan>
                                    <tspan x="0" y="46">«&nbsp;Prometheus&nbsp;»</tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-5">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">1987</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(323.000000, 235.000000)">
                            <g transform="translate(65.000000, 0.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Un premier véhicule autonome </tspan>
                                    <tspan x="0" y="30">réalise le trajet Munich-Copenhague</tspan>
                                </text>
                                <g transform="translate(0.000000, 57.000000)" class="button--plus" id="more-6">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g transform="translate(0.000000, 18.000000)">
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">1995</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(464.000000, 324.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Première compétition </tspan>
                                    <tspan x="0" y="30">de voitures sans </tspan>
                                    <tspan x="0" y="46">chauffeur</tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-7">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">2004</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(464.000000, 455.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Début du projet Auto-</tspan>
                                    <tspan x="0" y="30">Driving de Google</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-8">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2009</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(615.000000, 563.000000)">
                            <g transform="translate(65.000000, 28.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Nissan dans </tspan>
                                    <tspan x="0" y="30">la course</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-9">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">2013</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(704.000000, 415.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Publication du </tspan>
                                    <tspan x="0" y="30">rapport de la NHTSA</tspan>
                                </text>
                                 <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-10">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2014</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(704.000000, 284.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Tesla enclenche</tspan>
                                    <tspan x="0" y="30">la fonction «&nbsp;Pilote </tspan>
                                    <tspan x="0" y="46">automatique&nbsp;» </tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-11">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">2015</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(790.000000, 162.000000)">
                            <g transform="translate(65.000000, 0.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="34">Premier accident </tspan>
                                    <tspan x="0" y="50">pour la Google Car</tspan>
                                </text>
                                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                                    <tspan x="0" y="14">Mars</tspan>
                                </text>
                                <g transform="translate(0.000000, 71.000000)" class="button--plus" id="more-12">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g transform="translate(0.000000, 12.000000)">
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2016</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(930.000000, 242.000000)">
                            <g transform="translate(69.000000, 0.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="34">Expérimentation de </tspan>
                                    <tspan x="0" y="50">véhicules à délégation </tspan>
                                    <tspan x="0" y="66">de conduite en France</tspan>
                                </text>
                                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                                    <tspan x="0" y="14">Août</tspan>
                                </text>
                                <g transform="translate(0.000000, 78.000000)" class="button--plus" id="more-13">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g transform="translate(0.000000, 2.000000)">
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2016</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(934.000000, 373.000000)">
                            <g transform="translate(65.000000, 0.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="34">Une division dédiée à </tspan>
                                    <tspan x="0" y="50">la conduite autonome </tspan>
                                    <tspan x="0" y="66">chez Google</tspan>
                                </text>
                                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                                    <tspan x="0" y="14">Décembre</tspan>
                                </text>
                                <g transform="translate(0.000000, 78.000000)" class="button--plus" id="more-14">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g transform="translate(0.000000, 2.000000)">
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2016</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(1086.000000, 485.000000)">
                            <g transform="translate(65.000000, 28.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Des taxis autonomes </tspan>
                                    <tspan x="0" y="30">à Phoenix en Arizona</tspan>
                                </text>
                                <g transform="translate(0.000000, 41.000000)" class="button--plus" id="more-15">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">2018</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(1174.000000, 335.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">500.000 voitures </tspan>
                                    <tspan x="0" y="30">autonomes Nissan </tspan>
                                    <tspan x="0" y="46">sur les routes</tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-16">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                                    <tspan x="8" y="30.6666667">2020</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g >
                        <g transform="translate(1174.000000, 204.000000)">
                            <g transform="translate(65.000000, 18.000000)">
                                <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                                    <tspan x="0" y="14">Enquête ouverte </tspan>
                                    <tspan x="0" y="30">sur l'assistant à la </tspan>
                                    <tspan x="0" y="46">conduite de Tesla</tspan>
                                </text>
                                <g transform="translate(0.000000, 58.000000)" class="button--plus" id="more-17">
                                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                                </g>
                            </g>
                            <g>
                                <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                                    <tspan x="8" y="30.6666667">2021</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;


    const svgMobile = `
<svg id="Timeline" width="1533px" height="455px" viewBox="0 0 1533 455" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(1.000000, -3.000000)">
            <path d="M901.480288,-547.295103 L901.480288,-477.069517 C901.480288,-421.841042 856.708763,-377.069517 801.480288,-377.069517 L679.020248,-377.069517 C629.376915,-377.069517 589.133041,-336.825643 589.133041,-287.18231 L589.133041,-287.18231 C589.133041,-237.538976 629.376915,-197.295103 679.020248,-197.295103 L841.480288,-197.295103 C896.708763,-197.295103 941.480288,-152.523578 941.480288,-97.2951027 L941.480288,-57.2951027 C941.480288,-2.06662774 896.708763,42.7048973 841.480288,42.7048973 L689.32535,42.7048973 C634.096875,42.7048973 589.32535,87.4764223 589.32535,142.704897 C589.32535,142.844367 589.325642,142.983836 589.326225,143.123304 L589.489405,182.123304 C589.719801,237.187969 634.423383,281.704897 689.48853,281.704897 L841.480288,281.704897 C896.708763,281.704897 941.480288,326.476422 941.480288,381.704897 L941.480288,411.704897 C941.480288,466.933372 896.708763,511.704897 841.480288,511.704897 L689.906065,511.704897 C634.67759,511.704897 589.906065,556.476422 589.906065,611.704897 L589.906065,652.704897 C589.906065,707.933372 634.67759,752.704897 689.906065,752.704897 L841.480288,752.704897 C896.708763,752.704897 941.480288,797.476422 941.480288,852.704897 L941.480288,852.704897 L941.480288,983.09125" stroke="#74B743" stroke-width="2" stroke-linecap="square" transform="translate(765.193176, 217.898074) scale(-1, -1) rotate(90.000000) translate(-765.193176, -217.898074) "/>
            <path d="M1105.21576,90.2157593 L1105.16601,131.903579 C1105.10016,187.085416 1060.34796,231.784241 1005.16608,231.784241 L871.215759,231.784241" stroke="#EAF9DB" stroke-width="50" stroke-linecap="round" stroke-linejoin="round" transform="translate(988.215759, 161.000000) scale(-1, -1) rotate(90.000000) translate(-988.215759, -161.000000) "/>
            <g transform="translate(145.000000, 129.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Premier test</tspan>
                        <tspan x="0" y="30">au Japon</tspan>
                    </text>
                    <g class="button--plus" id="more-1" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">1977</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(145.000000, 260.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Arrivée de</tspan>
                        <tspan x="0" y="30">l’ABS</tspan>
                    </text>
                    <g class="button--plus" id="more-2" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">1978</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(256.000000, 368.000000)">
                <g transform="translate(65.000000, 29.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Première ligne de métro </tspan>
                        <tspan x="0" y="30">sans conducteur à Kobe</tspan>
                    </text>
                    <g class="button--plus" id="more-3" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">1981</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(325.000000, 260.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="15">La camionnette </tspan>
                        <tspan x="0" y="31">automatique de </tspan>
                        <tspan x="0" y="47">Mercedes-Benz</tspan>
                    </text>
                    <g class="button--plus" id="more-4" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">1984</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(325.000000, 129.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Lancement du </tspan>
                        <tspan x="0" y="30">programme européen </tspan>
                        <tspan x="0" y="46">« Prometheus »</tspan>
                    </text>
                    <g class="button--plus" id="more-5" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">1987</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(423.000000, 0.000000)">
                <g transform="translate(65.000000, 0.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Un premier véhicule autonome </tspan>
                        <tspan x="0" y="30">réalise le trajet Munich-Copenhague</tspan>
                    </text>
                    <g class="button--plus" id="more-6" transform="translate(0.000000, 57.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g transform="translate(0.000000, 18.000000)">
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">1995</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(564.000000, 125.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Première compétition </tspan>
                        <tspan x="0" y="30">de voitures sans </tspan>
                        <tspan x="0" y="46">chauffeur</tspan>
                    </text>
                    <g class="button--plus" id="more-7" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">2004</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(564.000000, 255.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Début du projet Auto-</tspan>
                        <tspan x="0" y="30">Driving de Google</tspan>
                    </text>
                    <g class="button--plus" id="more-8" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2009</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(715.000000, 358.000000)">
                <g transform="translate(65.000000, 28.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Nissan dans </tspan>
                        <tspan x="0" y="30">la course</tspan>
                    </text>
                    <g class="button--plus" id="more-9" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">2013</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(804.000000, 255.000000)">
                <g transform="translate(65.000000, 18.000000)" fill="#000000" font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16">
                    <text>
                        <tspan x="0" y="14">Publication du </tspan>
                        <tspan x="0" y="30">rapport de la NHTSA</tspan>
                    </text>
                </g>
                <g class="button--plus" id="more-10" transform="translate(65.000000, 59.000000)">
                    <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                    <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                </g>
                <g>
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2014</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(804.000000, 125.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Tesla enclenche</tspan>
                        <tspan x="0" y="30">la fonction « Pilote </tspan>
                        <tspan x="0" y="46">automatique » </tspan>
                    </text>
                    <g class="button--plus" id="more-11" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">2015</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(890.000000, 6.000000)">
                <g transform="translate(65.000000, 0.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="34">Premier accident </tspan>
                        <tspan x="0" y="50">pour la Google Car</tspan>
                    </text>
                    <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                        <tspan x="0" y="14">Mars</tspan>
                    </text>
                    <g class="button--plus" id="more-12" transform="translate(0.000000, 71.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g transform="translate(0.000000, 12.000000)">
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2016</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(1030.000000, 123.000000)">
                <g transform="translate(69.000000, 0.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="34">Expérimentation de </tspan>
                        <tspan x="0" y="50">véhicules à délégation </tspan>
                        <tspan x="0" y="66">de conduite en France</tspan>
                    </text>
                    <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                        <tspan x="0" y="14">Août</tspan>
                    </text>
                    <g class="button--plus" id="more-13" transform="translate(0.000000, 78.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g transform="translate(0.000000, 2.000000)">
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2016</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(1034.000000, 253.000000)">
                <g transform="translate(65.000000, 0.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="34">Une division dédiée à </tspan>
                        <tspan x="0" y="50">la conduite autonome </tspan>
                        <tspan x="0" y="66">chez Google</tspan>
                    </text>
                    <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" line-spacing="16" fill="#74B743">
                        <tspan x="0" y="14">Décembre</tspan>
                    </text>
                    <g class="button--plus" id="more-14" transform="translate(0.000000, 78.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g transform="translate(0.000000, 2.000000)">
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2016</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(1186.000000, 358.000000)">
                <g transform="translate(65.000000, 28.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Des taxis autonomes </tspan>
                        <tspan x="0" y="30">à Phoenix en Arizona</tspan>
                    </text>
                    <g class="button--plus" id="more-15" transform="translate(0.000000, 41.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">2018</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(1274.000000, 255.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">500.000 voitures </tspan>
                        <tspan x="0" y="30">autonomes Nissan </tspan>
                        <tspan x="0" y="46">sur les routes</tspan>
                    </text>
                    <g class="button--plus" id="more-16" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#74B743" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#FFFFFF">
                        <tspan  x="8" y="30.6666667">2020</tspan>
                    </text>
                </g>
            </g>
            <g transform="translate(1274.000000, 125.000000)">
                <g transform="translate(65.000000, 18.000000)">
                    <text font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" line-spacing="16" fill="#000000">
                        <tspan x="0" y="14">Enquête ouverte </tspan>
                        <tspan x="0" y="30">sur l'assistant à la </tspan>
                        <tspan x="0" y="46">conduite de Tesla</tspan>
                    </text>
                    <g class="button--plus" id="more-17" transform="translate(0.000000, 58.000000)">
                        <circle fill="#EAF9DB" cx="10" cy="10" r="10"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square"/>
                        <path d="M6,10 L14,10" stroke="#000000" stroke-linecap="square" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-10.000000, -10.000000) "/>
                    </g>
                </g>
                <g>
                    <circle fill="#B8E986" cx="25" cy="25" r="25" class="date--circle"/>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="17" fill="#417505">
                        <tspan  x="8" y="30.6666667">2021</tspan>
                    </text>
                </g>
            </g>
        </g>
    </g>
</svg>`


    return (
        <div className={styles.Wrapper}>
            <div className={styles.Main}>
                <div dangerouslySetInnerHTML={{__html: isMobile().phone ? svgMobile : svg}} ref={timeline}/>

                {
                    timelineText ?
                        <div className={styles.Text} ref={popin}>
                            <span className={styles.Plus} dangerouslySetInnerHTML={{__html: plus}} />
                            {timelineText}
                        </div>
                        : null
                }
            </div>
        </div>
    )
}
